import React from 'react';

const Interpret = () => {
  return (
    <div>
      
    </div>
  );
}

export default Interpret;
